import SmartInvestment from './SmartInvestment';

export default SmartInvestment;
